import { useEffect, useState } from "react";
import CookieFunctions from "../functions/CookieFunctions";
import File from "../components/File/File";
import { CCard, CCardBody, CCardTitle, CListGroup, CListGroupItem, CButton, CFormSelect } from "@coreui/react";

export default function Schedules() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileSelect = (e) => {
        const selectedIndex = e.target.selectedIndex;
        setSelectedFile(file[selectedIndex - 1]); // Adjust for the default disabled option
    };

    function getSchedules() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());
        const formData = new FormData();

        formData.append("fileType", "Schedules")

        fetch("/api/drivers/files",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData,
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
                
            } else {
                throw new Error()
            }
        }).then((data) => {
            setFile(data);
            setLoading(false);
        })
    }

    useEffect(() => {
        setLoading(true);
        getSchedules()
        
    }, [])

    return (
        <>
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <h3>Select a File:</h3>
                    <CFormSelect onChange={handleFileSelect} >
                        <option disabled selected>No file selected</option>
                        {file ? (
                            file.map((f, i) => (
                                <option key={i} value={f.fileBase64}>
                                    {f.fileName}
                                </option>
                            ))
                        ) : (
                            <option disabled>No files to show</option>
                        )}
                    </CFormSelect>
                    {selectedFile && (
                        <CCard style={{ backgroundColor: "transparent", border: 'none' }}>
                            <CCardBody>
                                <File file={`data:application/pdf;base64,${selectedFile.fileBase64}`} />
                            </CCardBody>
                        </CCard>
                    )}
                </>
            )}
        </>
    );
}

